module.exports = __webpack_public_path__ + "media/christmas_calm_music.b7f109aa.mp3";